import { render, staticRenderFns } from "./BirdLookup.vue?vue&type=template&id=b557e6ac"
import script from "./BirdLookup.vue?vue&type=script&lang=js"
export * from "./BirdLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports